import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'


export default class extends React.Component {
    static propTypes = {
		description: PropTypes.string,
		image: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		url: PropTypes.string,
	};

    render() {

		return (
	 		<div className="border-light-gray mbot20">
		 		<div className="row">
			 		<div className="col-sm-6">
			 			<a href={this.props.url} target="_blank">
							<div style={{ backgroundImage: 'url(' + this.props.image + ')', minHeight: '200px', backgroundSize: 'cover', backgroundPosition: '50%' }} />
						</a>
					</div>
			 		<div className="col-sm-6 pleft0 pright30 pleft20-xs pright20-xs pbot10-xs">
			 			<h4><a href={this.props.url} target="_blank">{this.props.title}</a></h4>
			 			<p className="small text-dark-gray">{this.props.description}</p>
			 		</div>
		 		</div>
		 	</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/PreviewParts/LinkPreview.jsx